<template>

<div class="shelves-right-wrap">
  <br><br><br>
  <p>采购车教程！！！！</p>
  <br><br>
<p>一定要看清楚，，，，认真脸，因为这个功能是为没有API对接的朋友们准备的哈~</p><br>
<p>做的很辛苦。。。。</p><br>
<br>
<p>我们希望把效率提高一些，并减少人工传导订单出现的失误和错误</p><br>
<p>可能这个功能还不足够酷炫~~~~~~~~</p><br>
<br>
<p>但请使用， 并提出意见~！@#￥%……AG</p><br>
<br>
<p>下面是步骤，其实很简单的，学会了，会说，哇塞~~~</p><br>
<br>
<p>1，必须把要买的东西，在货架内推送成生效状态。</p><br>
<p>生效的价格是您的最高可接受价，</p><br>
<p>系统会严防死守这条价格线。</p><br>
<p>结算时只会选比这个生效价格线便宜的给您结算，</p><br>
<p>不会给贵的~~</p><br>
<p>如果没有生效的货架数据，那系统就蒙圈了！</p><br>
<br><br>

<p>2，下载导入模板</p><br>
<p>把导入模板的信息填好，</p><br>
<p>其中SKU码最最最最最重要，</p><br>
<p>货架上的SKU码代表，要采购的东西。</p><br>
<br><br>

<p>3，上传！！！</p><br>
<p>嗯，默默的上传吧~~~~~</p><br>
<br><br>

<p>4，采购车会把所有数据识别一次。</p><br>
<p>根据提示，修改成 “可下单”状态。</p><br>
<p>然后去点去下单。</p><br>
<br>
<p>5，点下单后，会组合生成订单。</p><br>
<p>为什么要组合。</p><br>
<p>系统会按相同收件地址并且是同一个供应商的货合并起来。</p><br>
<p>这样只收一个运费。</p><br>
<p>就给您省钱了呀~~~~~~</p><br>
<p>生成订单后30分钟内占用库存，</p><br>
<p>时间到了自动消失。</p><br>
<br><br>

<p>6，账户里提前充好钱，</p><br>
<p>避免下单前没钱的尴尬。</p><br>


<p>7，下单成功后，可以问运营要发货的单号！~</p>
<p>他们会导出发货信息给您呦~---------</p>

<p>后面马上开发自己可以随便导出的功能。</p>

<p>8，每天来倒个千八百个订单吧。</p>
<br><br>

<p>注意事项：</p>
<p>问：为什么先充钱再买单。不做类似扫码支付这种功能。</p>
<p>答：因为线上扫码支付，支付宝微信都要收费率。 这种生意还没开始就给两位马爸爸交成本的事情，做运营的当然不答应。财务打款更便宜。</p>
<br>
<p>问：还有没有其他问题？</p>
<p>答：暂时没有。。。。</p>
<p>有的话，直接找对接运营，他们万能小助手。</p>
</div>
</template>

<script>

  export default {
    
  };
</script>

<style>
   .titleTemplate{
    text-align: center;
    font-size: 16px;
    font-weight: 800;

   }
   .Template-content div{
       text-indent:50px;
   }
</style>





// WEBPACK FOOTER //
// TemplateTeach.vue?d914875e